import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  MenuItem,
  TextField,
  Button,
  Paper
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { investorApi, vendorApi } from '../../api/api';
import { useLocation } from 'react-router-dom';

const AddEditablePropertyDocuments = () => {
    const location=useLocation();
    const {PropertyId,type} =location.state || {};
  const [selectedDocumentId, setSelectedDocumentId] = useState('');
  const [documents, setDocuments] = useState([]);
  const [file, setFile] = useState(null);

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const payload={
            propertyId:PropertyId,
            PropertyType:type
        }
        const response = await vendorApi.getDocumentsById(payload); 
        setDocuments(response.data);
      } catch (error) {
        console.error('Error fetching documents:', error);
      }
    };
    fetchDocuments();
  }, []);

  const handleUpload = async () => {
    if (!selectedDocumentId || !file) {
      alert('Please select a document and upload a file.');
      return;
    }

    const formData = new FormData();
    formData.append('propertyId',PropertyId);
    formData.append('id', selectedDocumentId);
    formData.append('Document', file);
    formData.append("PropertyType",type);

    try {
      const response = await investorApi.addEditableDocuments(formData); 
      alert('Document uploaded successfully!');
      setDocuments("");
      
    } catch (error) {
      console.error('Upload failed:', error);
      alert('Upload failed');
    }
  };

  return (
    <Paper elevation={3} sx={{ maxWidth: 500, p: 4, m: 'auto', mt: 4, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        Upload Editable Document
      </Typography>

      {/* Dynamic Document Dropdown */}
      <TextField
        label="Select Existing Document"
        select
        fullWidth
        value={selectedDocumentId}
        onChange={(e) => setSelectedDocumentId(e.target.value)}
        sx={{ mb: 2 }}
      >
        {documents.map((doc) => (
          <MenuItem key={doc.id} value={doc.id}>
            {doc.DocumentName}
          </MenuItem>
        ))}
      </TextField>

      {/* File Upload */}
      <Button
        variant="outlined"
        component="label"
        fullWidth
        startIcon={<CloudUploadIcon />}
        sx={{ mb: 2 }}
      >
        {file ? file.name : 'Upload Editable Version'}
        <input
          type="file"
          hidden
          onChange={(e) => setFile(e.target.files[0])}
        />
      </Button>

      {/* Submit */}
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleUpload}
      >
        Submit Editable Document
      </Button>
    </Paper>
  );
};

export default AddEditablePropertyDocuments;
